import { DEFAULT_POSTER_THEME_ID } from '@runtime/core/theme/posterThemes'
import { PLAY_CANONICAL_URL } from './shareApp'
const publicActivities = new Set([
  'strategy',
  'puzzle',
  'online',
  'challenges',
  'arcade',
  'ranking',
  'tools',
  'rules',
  'education',
])
export function buildPlayShareUrl(pathname: string, themeId: string, privatePoster = false) {
  const activity = pathname.split('/')[1]
  const route = publicActivities.has(activity) ? '/' + activity : '/home'
  const url = new URL(route, PLAY_CANONICAL_URL)
  if (themeId && themeId !== DEFAULT_POSTER_THEME_ID && !privatePoster)
    url.searchParams.set(route === '/home' ? 'poster' : 'theme', themeId)
  return url.href
}
